import styles from './TableStateOverlay.scss';

const TABLE_STATE_BORDER_PADDING = 6;
const TABLE_STATE_BORDER_RADIUS = 6;

interface TableStateOverlayProps {
  contentBounds: { x: number; y: number; width: number; height: number };
  viewBoxWidth: number;
  viewBoxHeight: number;
  stroke: string;
  showHoverStroke?: boolean;
  forceHoverStroke?: boolean;
}

export const TableStateOverlay = ({
  contentBounds,
  viewBoxWidth,
  viewBoxHeight,
  stroke,
  showHoverStroke,
  forceHoverStroke,
}: TableStateOverlayProps) => {
  const rectProps = {
    x: contentBounds.x - TABLE_STATE_BORDER_PADDING,
    y: contentBounds.y - TABLE_STATE_BORDER_PADDING,
    width: contentBounds.width + TABLE_STATE_BORDER_PADDING * 2,
    height: contentBounds.height + TABLE_STATE_BORDER_PADDING * 2,
    rx: TABLE_STATE_BORDER_RADIUS,
    ry: TABLE_STATE_BORDER_RADIUS,
    fill: 'none',
    stroke,
    vectorEffect: 'non-scaling-stroke',
  };
  return (
    <svg
      className={styles.tableStateOverlayWrapper}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    >
      <rect {...rectProps} className={styles.tableStateOverlayHighlight} />
      {(showHoverStroke || forceHoverStroke) && (
        <rect
          {...rectProps}
          className={styles.tableStateOverlayHighlight}
          style={{
            stroke: forceHoverStroke
              ? 'var(--white70)'
              : 'var(--floor-plan-hover-stroke, transparent)',
          }}
        />
      )}
    </svg>
  );
};
